export const frontmatter = {
    "draft": false,
    "title": "Vector Generator",
    "description": "Embedding and vector generation for knowledge base collections in OnnIA.",
    "sidebar_label": "Vector Generator",
    "sidebar_group": "reference",
    "sidebar_order": 2
}

export const toc = []